import React from 'react';
import ReactSVG from 'react-svg';
import LogoNuacom from '~/assets/images/logo-nuacom.svg';
import { LogoStyled } from './styles';

export default function LogoAuth() {
  return (
    <LogoStyled>
      <ReactSVG className="logo" src={LogoNuacom} alt="Nuacom" />
    </LogoStyled>
  );
}
